import styled from '@emotion/styled';
import breakpoints from '../Theme/breakpoints';

const ImageContainer = styled.div`
  && {
    .image-collection {
      height: auto;

      /* stylelint-disable-next-line selector-type-no-unknown */
      progressive-img, img {
        height: auto;
        --img-height: auto;
      }

      @media (min-width: ${breakpoints.sm}px) {
        height: 350px;

        /* stylelint-disable-next-line selector-type-no-unknown */
        progressive-img, img {
          height: 350px;
        --img-height: 350px;
      }
      }
    }
  }
`;

export default ImageContainer;
